import React, { useState, useEffect, useRef  } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { config } from '../config';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Messages } from 'primereact/messages';
import { Card } from 'primereact/card';
import Container from 'react-bootstrap/Container';
import {InputSwitch} from 'primereact/inputswitch';
import { useAuth } from '../contexts/AuthContext';
import { Toolbar } from 'primereact/toolbar';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import { Dropdown } from 'primereact/dropdown';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

import '../config.js'
import { create } from '@mui/material/styles/createTransitions.js';

const ComPorts = () => {
  // Load the status page script
  useStatusPageScript();
  
    const { clid } = useParams();
    const [comPorts, setComPorts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const msgs = useRef(null);
    const toastBC = useRef(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [selectedComPort, setSelectedComPort] = useState(null);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [accessPoints, setAccessPoints] = useState([]);
    const [newLMSPort, setNewLMSPort] = useState(null);
    const [newLMSAccessPoint, setNewLMSAccessPoint] = useState(null);
    const [newControllerPort, setNewControllerPort] = useState(null);
    const [newLMSType, setNewLMSType] = useState(null);
    const [newControllerType, setNewControllerType] = useState(null);
    const [createVisible, setCreateVisible] = useState(false);
    const toast = useRef(null);
    const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect({
      deniedTitle: 'COM Ports Access Denied',
      deniedMessage: 'You do not have permission to view or manage COM ports for this client.',
    });

useEffect(() => {
    const fetchComPorts = async () => {
        await getComPorts();
      };
  
      fetchComPorts();
}, [clid]);

const getComPorts = async () => {
  clearAccessIssue();
    setLoading(true);
    const token = localStorage.getItem('token');
    let header = {
        headers: {
        Authorization: `Bearer ${token}`,
        },
    }

    axios.get(`${global.config.url}/clients/comports/${clid}`, header)
        .then(response => {
            setComPorts(response.data);
            let aps = response.data.map(port => port.lmsPort.accessPoint);
            axios.get(`${global.config.url}/accesspoints/ByClient/${clid}`, header)
            .then(resp => {
              let ap = [];
              resp.data.forEach(item => {
                if(!aps.find(a => a.id === item.id)){
                  ap.push({ label: item.gate, value: item.id });
                }
              });
              setAccessPoints(ap);
              setLoading(false);
            });
        })
        .catch(async error => {
          if (handleAccessError(error)) {
            setLoading(false);
                return;
            }
            setError(error.message);
            setLoading(false);
            setComPorts([]);
        })
}

const footerContent = (
  <div>
      <Button label="No" icon="pi pi-times" onClick={() => setCreateVisible(false)} className="p-button-text" />
      <Button label="Yes" icon="pi pi-check" onClick={() => confirm(true)} autoFocus />
  </div>
);

const endContent = (
    <React.Fragment>
        <span className="p-input-icon-left mr-3 mt-1">
            {/* <i className="pi pi-search" /> */}
            {/* <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." /> */}
            <Button icon="pi pi-refresh" className="p-button-text" onClick={() => getComPorts()} disabled={loading} tooltip="Refresh COM ports" tooltipOptions={{position: "bottom"}}/>
            <Button icon="pi pi-trash" className="p-button-danger mx-3" rounded loading={deleteLoading} disabled={loading} onClick={() => confirm(null)} tooltip="Delete selected com port" tooltipOptions={{position: "bottom"}} />
            <Button icon="pi pi-plus" className="p-button-success p-mr-2" rounded loading={loading} disabled={loading} onClick={() => setCreateVisible(true)} tooltip='Add a new com port'/>
        </span>
    </React.Fragment>
);

const textEditor = (options) => {
    console.log(options);
    return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
};

const numberEditor = (options) => {
    console.log(options);
    return <InputText type="number" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
};

const onRowEditComplete = (rowData) => {
    confirm(false, rowData);
};


const addComPort = async (newData) => {
    try{
      clear(true);
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      if(newLMSPort === null || newLMSPort === undefined || newLMSPort === ""){
        msgs.current.show({severity: 'error', summary: '', detail: 'Please enter an LMS Port.'});
        return;
      }
      if(newLMSAccessPoint === null || newLMSAccessPoint === undefined){
        msgs.current.show({severity: 'error', summary: '', detail: 'Please select an Access Point.'});
        return;
      }
      if(newLMSType === null || newLMSType === undefined || newLMSType === ""){
        msgs.current.show({severity: 'error', summary: '', detail: 'Please enter an LMS Type.'});
        return;
      }
      if(newControllerType === null || newControllerType === undefined || newControllerType === ""){
        msgs.current.show({severity: 'error', summary: '', detail: 'Please enter a Controller Type.'});
        return;
      }
      let comPort = newControllerPort;
      if(comPort === null || comPort === undefined || comPort === "") {
        comPort = "-";
      }
      console.log(newLMSAccessPoint);
      const response = await axios.get(global.config.url + `/clients/addcomport/` +newLMSAccessPoint + `/lms/` 
        + newLMSPort + `/` + newLMSType + '/controller/' + comPort + `/` + newControllerType, axiosConfig);
      console.log(response);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: `COM ports successfully added.`});
        getComPorts();
        setCreateVisible(false);

      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error adding the COM Port.'});
      }
    } catch (error) {
      console.error('Error adding COM Port:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to create COM ports for this client.' })) {
        return;
      }
    }
  };

  const deleteComPort = async () => {
    try{
      clear(true);
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      if(selectedComPort === null){
        msgs.current.show({severity: 'error', summary: '', detail: 'Please select a COM port to delete.'});
        return;
      }
      let id = selectedComPort.lmsPort.accessPoint.id;
      const response = await axios.delete(global.config.url + `/clients/deletecomport/` + id, axiosConfig);
      console.log(response);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: `COM ports for tile ${selectedComPort.lmsPort.accessPoint.tile} successfully deleted.`});
        getComPorts();
        setSelectedComPort(null);
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error deleting the COM Port.'});
      }
    } catch (error) {
      console.error('Error deleting COM Port:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to delete this COM port.' })) {
        return;
      }
    }
  };

const confirm = (create, newData) => {
      toastBC.current.show({
        severity: 'info',
        sticky: true,
        className: 'border-none',
        content: (
            <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                <div className="text-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                    <div className="font-bold text-xl my-3">Are you sure?</div>
                </div>
                <div className="flex align-items-center">
                    {create === false &&<Button onClick={(e) => updateComPort(newData)} type="button" label="Yes" className="p-button-success w-6rem" />  }  
                    {create === null &&<Button onClick={(e) => deleteComPort()} type="button" label="Yes" className="p-button-success w-6rem" />  }
                    {create === true &&<Button onClick={(e) => addComPort(newData)} type="button" label="Yes" className="p-button-success w-6rem" />  }
                    <Button onClick={(e) => clear(false)} type="button" label="No" className="p-button-warning w-6rem mx-4" />
                </div>
            </div>
        )
      });
  
  };
  
  const clear = () => {
    toastBC.current.clear();
  };
  
  const updateComPort = async (newData) => {
    try{
      clear(true);
      if(newData.newData["lmsPort.comPort"] !== undefined){
        newData.newData.lmsPort.comPort = newData.newData["lmsPort.comPort"];
      }
      if(newData.newData["lmsPort.type"] !== undefined){
        newData.newData.lmsPort.type = newData.newData["lmsPort.type"];
      }
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      let id = newData.newData.id;
      let lmsPort = newData.newData.lmsPort.comPort;
      let comPort = newData.newData.comPort;
      if(comPort === null || comPort === undefined || comPort === "") {
        comPort = "-";
      }
      let type = newData.newData.type;
      let lmsType = newData.newData.lmsPort.type;
      const response = await axios.get(global.config.url + `/clients/editcomport/` + id + `/lms/` 
        +lmsPort + `/` + lmsType + '/controller/' + comPort + `/` + type, axiosConfig);
      console.log(response);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: `COM ports for client ${newData.newData.lmsPort.accessPoint.tile} successfully updated.`});
        getComPorts();
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error updating the COM Port.'});
      }
    } catch (error) {
      console.error('Error updating COM Port:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to update this COM port.' })) {
        return;
      }
    }
  };

if (accessIssue) {
    return <AccessState {...accessIssue} />;
}
  


return (

        <Container className ="justify-content-md-center mt-3">
        <div className="card">
            <Toolbar 
                start={
                <Container className="flex align-content-center flex-wrap">
                    <Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} className='flex'/> 
                    <h4 className='flex mt-2'>Com Ports</h4> 
                </Container>}
                end={endContent}/>
            </div>
            <Messages ref={msgs} />
            <Toast ref={toastBC} position="top-center" />
            <div className='justify-content-md-center mt-3'>
                <DataTable 
                    // ref={dt} 
                    value={comPorts}
                    // globalFilter={globalFilter}
                    dataKey="id"
                    selectionMode='single' selection={selectedComPort} onSelectionChange={(e) => setSelectedComPort(e.value)}
                    editMode='row' onRowEditComplete={onRowEditComplete} > 
                    <Column field="lmsPort.comPort" header="ST to LMS COM Port" sortable editor={(options) => textEditor(options)}/>
                    <Column field="comPort" header="Controller COM Port" sortable editor={(options) => textEditor(options)}/>
                    <Column field="lmsPort.accessPoint.tile" header="Tile ID" sortable/>
                    <Column field="lmsPort.accessPoint.client.name" header="Client Name"></Column>
                    <Column field="lmsPort.type" header="LMS port Type" sortable editor={(options) => numberEditor(options)}></Column>
                    <Column field="type" header="Controller port Type" sortable editor={(options) => numberEditor(options)}></Column>
                    <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                </DataTable>
            </div>
            <br></br>
            <p className="text-center">LMS type 0: Flow, LMS type 1: Gladstone access, LMS type 2: Gladstone Check-in, LMS type 3: Legend</p>
            <p className="text-center">Controller type 0: Ajax, Controller type 1: Nortech, Controller type 2: always when version 1.7.1</p>
            <div className="card flex justify-content-center">
          <Dialog header="Create COM port" className='justify-content-center' visible={createVisible} onHide={() => setCreateVisible(false)} 
            style={{ width: 'auto' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} footer={footerContent}>

            <Toast ref={toast} />
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4">
                <Dropdown
                  inputId="dd-accesspoint"
                  value={newLMSAccessPoint}
                  options={accessPoints}
                  onChange={(e) => setNewLMSAccessPoint(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select an Access Point"
                />
                <label htmlFor="dd_accesspoint">Select an Access Point</label>
              </span>
            </Container>
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4">
                <InputText
                    id="lmsport"
                    name="lmsport"
                    value={newLMSPort}
                    onChange={(e) => setNewLMSPort(e.target.value)}
                />
                <label htmlFor="lmsport">LMS Port</label>
              </span>
              <span className="flex p-float-label my-4 ml-3">
                <InputText
                    id="controllerport"
                    name="controllerport"
                    value={newControllerPort}
                    onChange={(e) => setNewControllerPort(e.target.value)}
                />
                <label htmlFor="controllerport">Controller Port</label>
              </span>
            </Container>
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4">
                <InputText
                    id="lmstype"
                    name="lmstype"
                    value={newLMSType}
                    onChange={(e) => setNewLMSType(e.target.value)}
                />
                <label htmlFor="lmstype">LMS Type</label>
              </span>
              <span className="flex p-float-label my-4 ml-3">
                <InputText
                    id="controllertype"
                    name="controllertype"
                    value={newControllerType}
                    onChange={(e) => setNewControllerType(e.target.value)}
                />
                <label htmlFor="controllertype">Controller Type</label>
              </span>
            </Container>
          </Dialog>
        </div>
        </Container>
);

}
export default ComPorts;